module.exports = __webpack_public_path__ + "img/rocketship-1.e6bd9811.webp";